// Descritor sem render: o Root o converte em `model` do Menu via `toItem`; o nome `view-` é exigência do contrato de estrutura.
import type { ItemProps } from "../types-table-actions-menu";

/** Item do painel (descritor: o Root o converte no `model` do `Menu`; não renderiza elemento próprio). */
export function TableActionsMenuItem(props: ItemProps): null {
  void props;
  return null;
}
TableActionsMenuItem.displayName = "TableActionsMenu.Item";
TableActionsMenuItem.toItem = (props: ItemProps): ItemProps => props;
